export class ShipmentOptions {
  returnOfDocument: boolean
  deskDelivery: boolean
  idCheck: boolean
  predict: boolean
  document: boolean
  b2c: boolean

  constructor(returnOfDocument: boolean, deskDelivery: boolean, idCheck: boolean, predict: boolean, document: boolean) {
    this.returnOfDocument = returnOfDocument
    this.deskDelivery = deskDelivery
    this.idCheck = idCheck
    this.predict = predict
    this.document = document
  }
}
